module.exports = __webpack_public_path__ + "static/Self-SustainableTeams-4d0af91b2461c3d9dd9d7957251fd01e.jpg";